//Resuable Component is created by mahtab, modal to add new contact
import React, { useDebugValue } from "react";
import { Flex, Modal, Form, Row, Col, message, Checkbox } from "antd";
import {
  CustomButton,
  CustomTitle,
  CustomInput,
  CustomDynamicSelect,
  CustomParagraph,
} from "../../components";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import { prefferedLanguages } from "../../common/static_data";

const AddNewContactModal = ({
  title,
  setEditingContact,
  form, // pass antd form obj e.g: const [form] = Form.useForm();
  modalOpen, // pass state value of open/close modal
  setModalOpen, // pass value to close modal
  apiCall, // pass complete api function to submit form
  isFormValid, // pass state that validate the form
}) => {
  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = { ...values };
      // console.log("Final model sent to API:", model);
      apiCall(model);
      console.log("model", model);
      // setModalOpen(false)
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setModalOpen(false);
    setEditingContact(null);
  };

  return (
    <Modal
      title=""
      centered
      open={modalOpen}
      onCancel={() => setModalOpen(false)}
      width={542}
      styles={{
        content: {
          padding: "24px 28px",
          borderRadius: "16px",
          overflow: "hidden",
        },
      }}
      // footer buttons
      footer={[
        <React.Fragment key="footer-actions">
          <Flex gap="16px" justify="end">
            <CustomButton
              key="button1"
              onClick={handleCancel}
              text={"Cancel"}
              bgColor="transparent"
              color="black"
              fontSize="14px"
              fontWeight="600"
              boxShadow="none"
              height="40px"
            />
            <CustomButton
              key="button2"
              text={"Save"}
              bgColor="black"
              color="white"
              height="40px"
              width="auto"
              fontSize="14px"
              fontWeight="600"
              boxShadow="none"
              borderRadius="8px"
              onClick={(e) => {
                e.stopPropagation();
                form.submit();
              }}
            />
          </Flex>
        </React.Fragment>,
      ]}
    >
      <CustomTitle
        style={{ position: "relative", left: "-5px" }}
        text={title}
        fontSize="24px"
        lineHeight="32px"
        fontWeight="700"
        marginBottom="0px"
      />
      <main
        style={{
          marginBottom: "20px",
          marginTop: "20px",
          marginRight: "-3px",
          marginLeft: "-5px",
        }}
      >
        <Form
          form={form}
          name="AddNewContact"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          initialValues={{ preferred_language: "English(US)" }}
        >
          <Row gutter={[0, 16]}>
            {/* name  */}
            <Col span={16}>
              <Form.Item
                className="custom-input form-input-style"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter name" },
                  {
                    pattern: /^[A-Za-z\s'-]+$/,
                    message: "Name must contain only letters",
                  },
                  { type: "text", message: "Please enter a valid name" },
                ]}
              >
                <CustomInput
                  placeholder="Enter name"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* title  */}
            <Col span={16}>
              <Form.Item
                className="custom-input form-input-style"
                label="Title"
                name="title"
                rules={[
                  { required: true, message: "Please enter title" },
                  { type: "text", message: "Please enter a valid title" },
                ]}
              >
                <CustomInput
                  placeholder="Enter title"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col span={16} style={{ display: "none" }}>
              <Form.Item
                className="custom-input form-input-style"
                name="country_code"
                rules={[
                  { required: false, message: "Please enter title" },
                  { type: "text", message: "Please enter a valid title" },
                ]}
              >
                <CustomInput
                  placeholder="Enter title"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* email  */}
            <Col span={16}>
              <Form.Item
                className="custom-input form-input-style"
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <CustomInput
                  placeholder="Enter email"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* phone number  */}
            <Col span={16}>
              <div className="">
                <Form.Item
                  label={"Phone number"}
                  name="phone_number"
                  style={{ marginBottom: "0px" }}
                  initialValue=""
                  // rules={[
                  //   {
                  //     validator: (_, value) => {
                  //       if (!value) {
                  //         return Promise.reject("Phone number is required");
                  //       }

                  //       const digitsOnly = value.replace(/\D/g, "");
                  //       if (digitsOnly.length >= 10) {
                  //         return Promise.resolve();
                  //       }
                  //       return Promise.reject("Please enter a valid phone number");
                  //     },
                  //   },
                  // ]}

                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value.trim() === "") {
                          return Promise.reject(
                            new Error("Please enter phone number")
                          ); // Reject if empty
                        }
                        try {
                          // Use libphonenumber to validate
                          if (isValidPhoneNumber(value)) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject(
                              new Error("Invalid phone number")
                            );
                          }
                        } catch (error) {
                          return Promise.reject(
                            new Error("Invalid phone number")
                          );
                        }
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    country={"us"}
                    value={form.getFieldValue("phone_number")}
                    onChange={(value, countryData, e, formattedValue) => {
                      form.setFieldsValue({ phone_number: formattedValue });
                    }}
                  />
                </Form.Item>
              </div>
            </Col>
            {/* Preffered language  */}

            <Col span={16}>
              <Form.Item
                className="custom-input form-input-style"
                label="Preferred language"
                name="preferred_language"
                rules={[{ required: false, message: "Please select value" }]}
                style={{ marginBottom: "0px" }}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                  // onChange={handleTemperatureRangeChange}
                  options={prefferedLanguages}
                />
              </Form.Item>
              <CustomParagraph
                text={"AI-generated communications will be in this language"}
                fontSize="12px"
                fontWeight="400"
                lineHeight="20px"
                marginBottom="0"
                marginTop={"8px"}
                color={"#5e5e5e"}
              />
            </Col>

            {/* primary contact  */}
            <Col span={24}>
              <Form.Item
                label=""
                name="is_primary_contact"
                valuePropName="checked"
              >
                <Checkbox>Make primary contact</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </main>
    </Modal>
  );
};

export default AddNewContactModal;

// example to call add new contact form

// const [openModal, setOpenModal] = useState(false);
// const [isFormValid, setIsFormValid] = useState(false);
// const [form] = Form.useForm();

// const submitNewContact = (model) => {
//   setIsFormValid(true);
//   showSpin();
//      EndPoint(token, model)
//     .then((res) => {
//       const data = res?.data || null;
//       if (data) {
//         if (data?.data?.is_success) {
//           message.success(data?.data?.message);
//           setIsFormValid(false)
//           form.resetFields();
//           setOpenModal(false)
//         } else {
//           message.error(data?.data?.message);
//         }
//       }
//     })
//     .catch((error) => {
//       unauthorize(error);
//     })
//     .finally(() => {
//       hideSpin();
//       setIsFormValid(false);
//     });
// };

// <AddNewContactModal
// form={form}
// modalOpen={openModal}
// setModalOpen={setOpenModal}
// apiCall={submitNewContact}
// isFormValid={isFormValid}
// />
// <p onClick={()=>setOpenModal(true)}>open Modal</p>
